import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ListSpaces {
	params?: NonNullable<Api.Operations['listSpaces']['parameters']>['query']
	response: Api.Operations['listSpaces']['responses']['200']['content']['application/json']
}

export const listSpaces = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListSpaces>(
		{
			method: 'get',
			url: '/spaces',
			...overideConfig,
		},
		axiosInstance,
	)
